import { WatermarkOptions } from '../../model/watermark';

export const watermarkOptionsDefaults: WatermarkOptions = {
	color: 'rgba(0, 0, 0, 0)',
	visible: false,
	fontSize: 48,
	text: '',
	horzAlign: 'center',
	vertAlign: 'center',
};
